<template>
  <div class="inputbtn-container">
    <template v-if="!options.includes('MAP')">
      <el-input
        v-model="input"
        clearable
        class="default-style"
        :placeholder="placeholder"
        :style="cssstyle"
      />
    </template>
    <template v-else>
      <el-input
        class="default-style"
        clearable
        :style="cssstyle"
        v-model="input"
        placeholder="请输入距离，最大1000km"
        oninput="value=value.replace(/[^\d]/g,'');if(value>1000)value=1000"
        slot="mapBtn-btns"
      >
        <template slot="append">km</template></el-input
      >
    </template>
    <el-button
      type="primary"
      @click="onSearch"
      class="search-btn"
      slot="submit-btns"
      >搜索</el-button
    >
  </div>
</template>

<script>
export default {
  name: "BtnInput",
  props: {
    cssstyle: {
      type: Object,
      default() {
        return {};
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "请输入关键字，比如招标名称、采购单位名称等",
    },
    isCondition: {
      // false-默认进入筛选条件初始化
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    showSearchMode: {
      type: Array,
      default() {
        return [];
      },
    },
    isForm: {
      // 是否是form表单
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: "",
      curentField: ''
    };
  },
  watch: {
    input(val) {
      //   this.$emit("click", { val: val, field: this.field, isCondition: this.isCondition });
    },
  },
  mounted() {
    this.input = this.value;
    this.curentField = this.field
    this.$emit("initFormData", {
      val: this.input,
      field: this.field,
      isCondition: this.isCondition,
      showSearchMode: this.showSearchMode,
      isForm: this.isForm
    });
  },
  methods: {
    onSearch() {
      this.$emit("click", {
        val: this.input,
        field: this.field,
        isCondition: this.isCondition,
        showSearchMode: this.showSearchMode,
        isForm: this.isForm
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.inputbtn-container {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  flex: 1;
  .default-style {
    height: 30px;
    // width: 300px;
    /deep/ .el-input__inner {
      height: 100%;
      border-radius: 0;
    }
  }
  .search-btn {
    border-radius: 0 !important;
    background-color: #e40e1b !important;
    border-color: #e40e1b !important;
    margin-left: 10px !important;
    width: 54px;
    height: 30px;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
}
</style>
